function updateProgressbar(collectionId, amount) {
    const $collection = document.querySelector(
        `[data-collection="${collectionId}"]`
    );
    if (!$collection) {
        console.warn(`Коллекция с ID ${collectionId} отсутствует!`);
        return;
    }

    const $textAccent = $collection.querySelector(
        '.collection-progress .text-accent'
    );
    const $progressBar = $collection.querySelector(
        '.collection-progress__bar .fill'
    );

    if (!$textAccent || !$progressBar) {
        return;
    }

    const count = Number($progressBar.getAttribute('data-count'));
    const max = Number($progressBar.getAttribute('data-max'));
    const result = count + amount;

    $textAccent.textContent = result;
    $progressBar.setAttribute('data-count', result);
    const isCompleted = result === max;
    $progressBar.style.width = isCompleted
        ? 'calc(100% - 4px)'
        : `${(result / max) * 100}%`;
    $progressBar.classList.toggle('completed', isCompleted);
}

export default function Collections() {
    // добавить предмет коллекции в корзину
    eventDelegate.addEvent(
        'click',
        '.lot__button.add-to-cart',
        function addCollectionItemToCart() {
            const itemId = this.getAttribute('data-item-id');
            MNTK.emit('addToCart', itemId);
            MNTK.emit('cartRender');
            this.classList.add('d-none');
            this.parentNode.insertAdjacentHTML(
                'beforeend',
                '<a href="/checkout" class="lot__link lot__link_accent" target="_blank">В корзине</a>'
            );
        }
    );

    // кнопка "Показать еще" на странице просмотра коллекции
    eventDelegate.addEvent(
        'click',
        'button.collection__btn-block',
        function showAllElements() {
            const $container = this.closest('.collection__content');
            $container
                .querySelectorAll('.collection__lot.hidden')
                .forEach($lot => $lot.classList.remove('hidden'));
            this.classList.add('d-none');
        }
    );

    // кнопки "У меня это есть" / "Убрать из коллекции"
    eventDelegate.addEvent(
        'click',
        '.lot__button[data-own]',
        async function () {
            const $card = this.closest('.lot');
            const itemId = this.getAttribute('data-item-id');
            const type = this.getAttribute('data-own');

            $card.classList.add('loading');

            try {
                await MNTK.fetchJson(
                    Routing.generate(`api.web.owned_lot.${type}`, { itemId, removeEverything: 1 }),
                    { method: 'POST' }
                );
                $card.classList.toggle('lot_owned');
                $card.classList.remove('loading');

                const $collection = this.closest('[data-collection]');
                if ($collection) {
                    updateProgressbar(
                        $collection.getAttribute('data-collection'),
                        type === 'add' ? 1 : -1
                    );
                }
            } catch (error) {
                console.log(error);
                $card.classList.remove('loading');
                window.openMessageModal();
            }
        }
    );

    function canUseWebp(imageUrl) {
        // Check browser allowed webp
        let canUse = false;
        let canvasEl = document.createElement('canvas');
        if (canvasEl.getContext && canvasEl.getContext('2d')) {
            canUse = canvasEl.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }

        // Check has webp
        let issetWebp = false;
        if (canUse) {
            var http = new XMLHttpRequest();
            http.open('HEAD', imageUrl, false);
            http.send();
            issetWebp = http.status !== 404;
        }
        return issetWebp;
    }

    // load lazy bg
    const observerBg = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let img = entry.target.dataset.bg;
                const imgWebp = img.split('.').slice(0, -1).join('.') + '.webp';

                if (canUseWebp(imgWebp)) {
                    img = imgWebp;
                }

                if (img.indexOf('logo.svg') === -1) { // linear-gradient(rgba(0, 0, 0, 0.95), rgba(255, 255, 255, 0)),
                    entry.target.style.backgroundImage = "linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(255,255,255,0) 40%, rgba(255,255,255,0) 59%, rgba(0,0,0,0.5) 100%), url('" + img + "')"
                }

                observer.unobserve(entry.target)
            }
        })
    }, { threshold: 0.5 })
    document.querySelectorAll('.collection-card-bg-lazy').forEach(el => observerBg.observe(el))
}
